import React from 'react';
import { Table, Alert } from 'react-bootstrap';

const ReviewCommissionsTable = ({ comisiones }) => {
  if (!comisiones || comisiones.length === 0) {
    return <Alert variant="info">No hay comisiones para revisar.</Alert>;
  }

  const headers = Object.keys(comisiones[0]);

  return (
    <Table striped bordered hover responsive size="sm">
      <thead>
        <tr>
          {headers.map(header => <th key={header}>{header}</th>)}
        </tr>
      </thead>
      <tbody>
        {comisiones.map((comision, index) => (
          <tr key={index}>
            {headers.map(header => <td key={header}>{comision[header]}</td>)}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ReviewCommissionsTable;
